import FormElement from 'app/components/Form/FormElement/FormElement';
import { selectSpecialty } from 'app/containers/User/selectors';
import { getStore } from 'app/reduxStore/configureStore';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { Act, ActContextElement } from 'shared/medyx-core/types/act';
import { UserSpecialty } from 'shared/medyx-core/types/user';
import { ACT_FORM_NAME, actFormFields } from '../constants';
import { UnknownAction } from '@reduxjs/toolkit';
import SingleSelectCheckboxGroup from 'app/components/Form/Checkbox/SingleSelectCheckboxGroup/SingleSelectCheckboxGroup';
import CheckboxGroup from 'app/components/Form/Checkbox/CheckboxGroup/CheckboxGroup';
import BasicField from 'app/components/Form/BasicField';

interface Props {
  act: Act;
}

const IS_PRESENT_PER_SPECIALTY: Record<UserSpecialty, boolean> = {
  [UserSpecialty.ANESTHESIOLOGIST]: true,
  [UserSpecialty.ANESTHESIOLOGIST_INTENSIVIST]: true,
  [UserSpecialty.CARDIOLOGIST]: false,
  [UserSpecialty.ENDOCRINOLOGIST]: false,
  [UserSpecialty.GENERAL_SURGEON]: false,
  [UserSpecialty.INTERNIST]: false,
  [UserSpecialty.ORTHOPEDIC_SURGEON]: false,
  [UserSpecialty.OTOLARYNGOLOGIST]: false,
  [UserSpecialty.PNEUMOLOGIST]: false
};

function SeriousEmergencyField({ input, act, ...props }) {
  return (
    <BasicField
      label={props.label}
      InputLabelProps={{
        shrink: true,
        style: { position: 'inherit' }
      }}
      {...props}
    >
      <CheckboxGroup
        checkboxes={[
          { label: 'Oui', value: true },
          { label: 'Non', value: false }
        ]}
        onCheckboxSelected={(value) => {
          if (value === true && !act.contextElements?.includes(ActContextElement.SERIOUS_EMERGENCY)) {
            input.onChange([...act.contextElements, ActContextElement.SERIOUS_EMERGENCY]);
          }

          if (value === false && act.contextElements?.includes(ActContextElement.SERIOUS_EMERGENCY)) {
            input.onChange([
              ...act.contextElements.filter((element) => element !== ActContextElement.SERIOUS_EMERGENCY)
            ]);
          }
        }}
        isChecked={({ value }) => act.contextElements?.includes(ActContextElement.SERIOUS_EMERGENCY) === value}
      />
    </BasicField>
  );
}

const SeriousEmergency = ({ act }: Props) => {
  const dispatch = useDispatch();
  const specialty = selectSpecialty()(getStore().getState());

  // We need to remove the serious emergency context element if the urgent context element is unselected
  useEffect(() => {
    if (
      !act.contextElements?.includes(ActContextElement.URGENT) &&
      act.contextElements?.includes(ActContextElement.SERIOUS_EMERGENCY)
    ) {
      dispatch(
        change(ACT_FORM_NAME, `${actFormFields.contextElements}`, [
          ...act.contextElements.filter((element) => element !== ActContextElement.SERIOUS_EMERGENCY)
        ]) as UnknownAction
      );
    }
  }, [act.contextElements, dispatch]);

  if (!IS_PRESENT_PER_SPECIALTY[specialty] || !act.contextElements?.includes(ActContextElement.URGENT)) return null;

  return (
    <FormElement
      label="Anesthésie simultanée - Urgence grave ?"
      name={actFormFields.contextElements}
      component={SeriousEmergencyField}
      act={act}
    />
  );
};

export default SeriousEmergency;
